export const formatUploadName = upload => {
  if (upload.files?.length === 1) {
    return upload.files[0];
  }

  // multi file formats (shp): display the primary file name
  const baseFile = upload.files.find(file => {
    // special handling for shapefiles.
    // If we need special handling for more file types,
    // consider adding some kind of file naming to the backend.
    return file.endsWith('.shp');
  });

  if (baseFile) {
    return baseFile;
  }

  // fall back on listing all files
  return upload.files.join(', ');
};
